import { render, staticRenderFns } from "./CompensationProcedureRaiseWorkersRangesByBands.vue?vue&type=template&id=1378c41e"
import script from "./CompensationProcedureRaiseWorkersRangesByBands.vue?vue&type=script&lang=js"
export * from "./CompensationProcedureRaiseWorkersRangesByBands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports